// @flow

// Libs
import React from 'react'

// Components
import TopBar from './TopBar'
import BottomBar from './BottomBar'
import MenuLayout from './Menu'
import { Eula } from 'hfty-components-auth'

// Constants
import { MOBILE_BREAK_POINT } from 'hfty'

// Containers
import layerContainer from '../containers/Layout'

// Styles
import { primary, white } from 'hfty-styles/src/colors'

const styles = {
  container: {
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: primary(),
    overflow: 'auto',
  },
  contentContainer: {
    position: 'relative',
    flex: '1 1 auto',
    display: 'flex',
    overflow: 'auto',
    backgroundColor: white(),
  },
}

// Types
type Props = {
  children: ?React.Element<any>,
  viewport: Object,
  toggled: boolean,
  userlabel: string,
  activeRoute: string,
  seasons: Object,
  farms: Object,
  selectedSeason: Object,
  selectedFarm: Object,
  onChangeFarm: Function,
  onChangeSeason: Function,
  onToggle: Function,
  logout: Function,
  push: Function,
  username: string,
}

type EULAProps = {
  isAuthenticated: boolean,
  eulaSigned: boolean,
  isFetchingEulaSigned: boolean,
}

function LayoutDisplay (props: EULAProps & Props): React.Element<any> {
  const eulaNotDone = props.isAuthenticated && !props.isFetchingEulaSigned && !props.eulaSigned

  return eulaNotDone
    ? (<div style={styles.container} ><Eula /></div>)
    : (
      <LayoutControl {...props} />
    )
}

const LayoutControl = (props: EULAProps & Props): React.Element<any> => {
  const {
    isAuthenticated,
    viewport,
  } = props
  const isMobile = viewport.width < MOBILE_BREAK_POINT

  if (isMobile && isAuthenticated) {
    return <LayoutMobile {...props} />
  } else {
    return <LayoutDesktop {...props} />
  }
}

const LayoutMobile = (props: EULAProps & Props): React.Element<any> => {
  return (
    <div style={styles.container} data-test='hfty-layout/Layout'>
      <MenuLayout
        activeRoute={props.activeRoute}
        mobile
        toggled={props.toggled}
        onChangeFarm={props.onChangeFarm}
        onChangeSeason={props.onChangeSeason}
        selectedSeason={props.selectedSeason}
        selectedFarm={props.selectedFarm}
        farms={props.farms}
        seasons={props.seasons}
        onToggle={props.onToggle}
        logout={props.logout}
        push={props.push}
        username={props.username}
      />
      <div style={styles.contentContainer}>
        {props.children}
      </div>
    </div>
  )
}

const LayoutDesktop = (props: EULAProps & Props): React.Element<any> => {
  return (
    <div style={styles.container} data-test='hfty-layout/Layout'>
      <TopBar
        isAuthenticated={props.isAuthenticated}
        logout={props.logout}
        userlabel={props.userlabel}
        onChangeFarm={props.onChangeFarm}
        onChangeSeason={props.onChangeSeason}
        selectedSeason={props.selectedSeason}
        selectedFarm={props.selectedFarm}
        farms={props.farms}
        seasons={props.seasons}
        push={props.push}
      >
        {props.isAuthenticated
          ? <MenuLayout
            activeRoute={props.activeRoute}
            mobile={false}
            toggled={props.toggled} />
          : null
        }
      </TopBar>
      <div style={styles.contentContainer}>
        {props.children}
      </div>
      <BottomBar
        isAuthenticated={props.isAuthenticated}
        logout={props.logout} />
    </div>
  )
}

export default layerContainer(LayoutDisplay)
